declare var Tawk_API: any;

export function showChatWidget() {
  Tawk_API?.showWidget && Tawk_API.showWidget();
}

export function hideChatWidget() {
  Tawk_API?.hideWidget && Tawk_API.hideWidget();
}
